import React, { createContext, useContext, useState, useCallback } from "react";
import BookNowModal from "../components/BookNowModal/BookNowModal";

const BookNowContext = createContext(null);

export const useBookNow = () => {
  const ctx = useContext(BookNowContext);
  if (!ctx) {
    throw new Error("useBookNow must be used within BookNowProvider");
  }
  return ctx;
};

export const BookNowProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [sourcePage, setSourcePage] = useState("other");

  const openBookNow = useCallback((page = "other") => {
    setSourcePage(page);
    setIsOpen(true);
  }, []);

  const closeBookNow = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <BookNowContext.Provider value={{ openBookNow, closeBookNow, isOpen }}>
      {children}
      <BookNowModal
        isOpen={isOpen}
        onClose={closeBookNow}
        sourcePage={sourcePage}
      />
    </BookNowContext.Provider>
  );
};
